import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const ImportantInformationStripModuleAsyncComponent = AsyncComponent(async () => import('./important-information-strip-module' /* webpackChunkName: "important-information-strip-module" */ ));

export const ImportantInformationStripModuleAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <ImportantInformationStripModuleAsyncComponent {...props}/>
  </React.Suspense>
}
